import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { SfinxThemeBgSensitiveDatahandler } from '../../utils/SfinxThemeBgSensitiveDatahandler';

export const Indications = ({ children }: React.PropsWithChildren) => {
  return (
    <Box
      width="100%"
      zIndex={2}
      left={0}
      bottom={0}
      position="absolute"
      p="space6"
      flexDirection="row"
      justifyContent="flex-end"
      gap="space3"
    >
      <SfinxThemeBgSensitiveDatahandler>
        {children}
      </SfinxThemeBgSensitiveDatahandler>
    </Box>
  );
};
